import { render, staticRenderFns } from "./FairnessSubplotRelative.vue?vue&type=template&id=fd9ab614&"
import script from "./FairnessSubplotRelative.vue?vue&type=script&lang=js&"
export * from "./FairnessSubplotRelative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports